/* eslint-disable react/no-array-index-key */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { changeBookBackgroundType } from './../../../../../../redux/actions/ui/bookProperties';
import { addBackgroundPropertyToPage } from '../../../../../../redux/actions/entities/pages';
import { GetActivePage } from '../../../../../../redux/helpers';
import { getBackgrounsByLayoutType } from '../../../../../../redux/helpers/layouts';


class ParentCategory extends React.Component {
  constructor(props) {
    super(props);
  }


  setBackgroundType = (type) => {
    const { pagesById } = this.props;
    const currentPage = GetActivePage(pagesById);
    this.props.dispatch(changeBookBackgroundType(type));
    this.props.dispatch(addBackgroundPropertyToPage(currentPage.id, 'type', type));
  }


  displayComponent = () => {
    const { layouts, pagesById } = this.props;
    const { backgrounds } = this.props;

    if (Object.keys(backgrounds).length > 0) {
      const backgroundByType = getBackgrounsByLayoutType(pagesById, layouts, backgrounds);
      if (backgroundByType) {
        return backgroundByType.map((element, index) => <li key={`parent-${index}`} onClick={() => { this.setBackgroundType(element.name); }} >{element.name}</li>);
      }
    }
    return null;
  }
  render() {
    return (
      <div className="listBody ">
        <ol>
          {this.displayComponent()}
        </ol>
      </div>

    );
  }
}

ParentCategory.defaultProps = {
  lang: {},
  pagesById: {},
  dispatch: () => {},
  layouts: {},
};

ParentCategory.propTypes = {
  dispatch: PropTypes.func,
  lang: PropTypes.object,
  pagesById: PropTypes.object,
  layouts: PropTypes.object,
};

export default connect()(ParentCategory);




// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/page-background-color/parent-category/ParentCategory.jsx